import styled from "styled-components";

const TodayCommunityWrapper = styled.div`
  margin-top: 40px;
  padding: 0 16px;

  .community-card-wrapper {
    ::-webkit-scrollbar {
      display: none;
    }

    .container {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
    }
    .community-card {
      flex: 0 0 auto;
      margin-right: 8px;
      cursor: pointer;
      width: 256px;
      padding: 16px;
      margin-top: 8px;
      border-radius: 8px;
      background-color: #fff8f0;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        p:first-child {
          padding: 2px 4px;
          background-color: #ffe4c8;
          border-radius: 4px;
          color: #4a5056;
          font-size: 12px;
          font-weight: 400;
        }

        p:last-child {
          font-weight: 400;
          font-size: 12px;
          color: #878e95;
        }
      }

      .card-content {
        margin-top: 12px;
        font-weight: 400;
        font-size: 14px;
      }

      .card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;

        p:first-child {
          font-weight: 400;
          font-size: 12px;
          color: #878e95;
        }

        > div {
          display: flex;

          > span {
            display: flex;
            font-weight: 400;
            font-size: 12px;
            color: #878e95;

            :first-child {
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
`;

export { TodayCommunityWrapper };
